export enum TipoUsuarioEnum{
  admin,
  gestorAdmin,
  gestor,
  assistente,
  cliente,
  usuario,
  sdr
}
